import {Injectable} from '@angular/core';
import {Observable, of, merge} from 'rxjs';

import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {UserStore} from '@stores/user.store';
import {EventAPIService, SendEventInput} from '@services/event-api.service';
import {ServiceDecorator} from './service-decorator';

@Injectable()
export class EventIdManagerDecorator
  implements EventAPIService, ServiceDecorator<EventAPIService>
{
  private _service: EventAPIService;

  constructor(private userStore: UserStore) {}

  setService(service: EventAPIService): void {
    this._service = service;
  }

  sendEvent(input: SendEventInput): Observable<string | void> {
    if (U.isEmpty(this._service)) {
      throw new Error('[EventIdManagerDecorator]service not initialized');
    }

    const user = this.userStore.state();
    const trackingId = U.generateId();
    return merge(
      of(trackingId),
      this._service.sendEvent({
        ...input,
        trackingId: trackingId,
        clientId: user?.clientId,
      }),
    );
  }
}
